import * as React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./Ops.CardTerminals.List";

const CardTerminals = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/card_terminals"
      render={() => <List {...props} />}
    />
  </Switch>
);

export default CardTerminals;
